import config from "../config.json";
export const log = (message?: any, ...optionalParams: any[]) => {
  if (config.LOG) {
    console.log(message, ...optionalParams);
  }
};
